module.exports = __webpack_public_path__ + "img/area-5-8.fad6b8e.jpg";